import { IBlogPost, IBlogPostReduced } from '@/_types'

/**
 * Get the cover photo for a blog post
 * @param blogPost - The blog post to get the cover photo for
 * @returns The cover photo
 */
export const getBlogPostCover = (blogPost: IBlogPostReduced | IBlogPost) => {
	if (!blogPost) return null

	return (
		blogPost.coverPhoto ||
		blogPost.previewPhoto ||
		blogPost.coverPhotoMobile ||
		blogPost.previewPhotoMobile ||
		getFallbackImage()
	)
}

/**
 * Get the cover photo for a blog post on mobile
 * @param blogPost - The blog post to get the cover photo for
 * @returns The cover photo
 */
export const getBlogPostCoverMobile = (blogPost: IBlogPostReduced | IBlogPost) => {
	if (!blogPost) return null

	return (
		blogPost.coverPhotoMobile ||
		blogPost.coverPhoto ||
		blogPost.previewPhoto ||
		blogPost.previewPhotoMobile ||
		getFallbackImage()
	)
}

/**
 * Get the preview photo for a blog post
 * @param blogPost - The blog post to get the preview photo for
 * @returns The preview photo
 */
export const getBlogPostPreviewPhoto = (blogPost: IBlogPostReduced | IBlogPost) => {
	if (!blogPost) return null

	return (
		blogPost.previewPhoto ||
		blogPost.coverPhoto ||
		blogPost.coverPhotoMobile ||
		blogPost.previewPhotoMobile ||
		getFallbackImage()
	)
}

/**
 * Get the preview photo for a blog post on mobile
 * @param blogPost - The blog post to get the preview photo for
 * @returns The preview photo
 */
export const getBlogPostPreviewPhotoMobile = (blogPost: IBlogPostReduced | IBlogPost) => {
	if (!blogPost) return null

	return (
		blogPost.previewPhoto ||
		blogPost.coverPhoto ||
		blogPost.coverPhotoMobile ||
		blogPost.previewPhotoMobile ||
		getFallbackImage()
	)
}

export const getFeaturedBlogPostPreviewPhotoMobile = (blogPost: IBlogPostReduced | IBlogPost) => {
	if (!blogPost) return null

	return (
		blogPost.previewPhotoMobile ||
		blogPost.coverPhotoMobile ||
		blogPost.previewPhoto ||
		blogPost.coverPhoto ||
		getFallbackImage()
	)
}

/**
 * Get the fallback image
 * @returns The fallback image
 */
export const getFallbackImage = () => {
	return null
}
